import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCurrentSite } from '@/contexts/SiteContext';
import { pageNameForPath } from '@/lib/pageNames';
import { useDynamicPageName } from '@/hooks/useDynamicPageName';

// useDocumentTitle keeps document.title in sync with the active route plus
// the active site. Format: `<Page> · <Site> · AEO Platform` on site-scoped
// routes, or `<Page> · AEO Platform` on global routes.
export function useDocumentTitle(): void {
  const location = useLocation();
  const dynamicName = useDynamicPageName(location.pathname);
  const { currentSite } = useCurrentSite();
  useEffect(() => {
    const page = dynamicName ?? pageNameForPath(location.pathname);
    const parts = [page];
    if (currentSite) parts.push(currentSite.name);
    parts.push('AEO Platform');
    document.title = parts.join(' · ');
  }, [location.pathname, dynamicName, currentSite]);
}
